import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AudienciaDetalleResponse, CelebrarAudienciaParams, CelebrarAudienciaResponse, defaultAudienciaDetalle, defaultCelebrarAudiencia, GuardarInformacionParams, GuardarAsistentesParams, GuardarAnexosParams, GuardarPromocionesParams, ActualizarEstatusAudienciaParams, ActualizarEstatusAudienciaResponse, defaultActualizarEstatusAudiencia, ActualizarActaAudienciaParams, GuardarNotificacionesParams, ObtenerAgendaAudienciasParams, defaultObtenerAgendaAudienciasResponse, ObtenerAgendaAudienciasResponse, DescargarInformacionParams } from '../../interfaces/audiencias/AudienciaInterface';

export const CelebrarAudiencia = ( params: CelebrarAudienciaParams ) => {

    return new Promise<CelebrarAudienciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/CelebrarAudiencia/', params, token)
            .then( ({ data } : { data : CelebrarAudienciaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultCelebrarAudiencia, message: error.message } );
            });

        }

    });

}

export const DetalleAudiencia = ( id: string ) => {

    return new Promise<AudienciaDetalleResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Audiencia/DetalleAudiencia/${id}`, token)
            .then( ({ data } : { data : AudienciaDetalleResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultAudienciaDetalle, message: error.message } );
            });

        }

    });

}

export const GuardarInformacion = ( params: GuardarInformacionParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/GuardarInformacion/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const GuardarAsistentes = ( params: GuardarAsistentesParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/GuardarAsistentes/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const GuardarNotificaciones = ( params: GuardarNotificacionesParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/GuardarNotificaciones/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const GuardarAnexos = ( params: GuardarAnexosParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/GuardarAnexos/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const GuardarPromociones = ( params: GuardarPromocionesParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/GuardarPromociones/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ActualizarEstatusAudiencia = ( params: ActualizarEstatusAudienciaParams ) => {

    return new Promise<ActualizarEstatusAudienciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/ActualizarEstatus/', params, token)
            .then( ({ data } : { data : ActualizarEstatusAudienciaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultActualizarEstatusAudiencia, message: error.message } );
            });

        }

    });

}

export const ActualizarActaAudiencia = ( params: ActualizarActaAudienciaParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/GuardarActaAudiencia/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerAgendaAudiencias = async ( params: ObtenerAgendaAudienciasParams ) => {

    return new Promise<ObtenerAgendaAudienciasResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '{}' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Audiencia/ObtenerAgendaAudiencias/', params, token)
            .then( ({ data } : { data : ObtenerAgendaAudienciasResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultObtenerAgendaAudienciasResponse });
            });

        }

    });

};

export const DescargarInformacionAudiencias = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/Audiencia/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
